/* ==========================================================================
   HOME PASSION · scroll-driven sahneler

   NOT (olculdu): bu temada 'scroll' olayi ve requestAnimationFrame bazi
   durumlarda hic tetiklenmiyor — o zaman sahneler ilerlemiyor, bolum
   ekranda kilitli kaliyor. Bu yuzden motor artik olaya bagimli DEGIL:
   bolum ekrandayken 60ms'de bir scrollY karsilastiriliyor. Bolum gorus
   disina cikinca yoklama tamamen duruyor, yani bedava.
   ========================================================================== */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    (root||document).querySelectorAll('.hp-scenes').forEach(function(sec){
      if(sec.dataset.init) return; sec.dataset.init='1';

      var imgs=[].slice.call(sec.querySelectorAll('.hp-sc-img'));
      var txts=[].slice.call(sec.querySelectorAll('.hp-sc-txt'));
      var dots=[].slice.call(sec.querySelectorAll('.hp-sc-dot i'));
      var n=Math.max(imgs.length,1);

      if(RM){
        imgs[0] && imgs[0].classList.add('on');
        txts.forEach(function(t){ t.classList.add('on'); });
        return;
      }

      /* her sahne icin data-per kadar kaydirma + 1 ekran pin */
      var per=parseFloat(sec.dataset.per||'100');
      sec.style.height=(n*per+100)+'vh';

      var cur=-1, lastY=-1, timer=null;

      function upd(force){
        var y=window.pageYOffset||document.documentElement.scrollTop||0;
        if(!force && y===lastY) return;
        lastY=y;

        var r=sec.getBoundingClientRect();
        var total=sec.offsetHeight-window.innerHeight;
        if(total<=0) return;
        var p=Math.min(1,Math.max(0,(-r.top)/total));
        var f=p*n;
        var i=Math.min(n-1,Math.floor(f));
        var local=Math.min(1,Math.max(0,f-i));

        if(i!==cur){
          cur=i;
          imgs.forEach(function(el,k){ el.classList.toggle('on',k===i); });
          txts.forEach(function(el,k){ el.classList.toggle('on',k===i); });
        }
        if(imgs[i]){
          var im=imgs[i].querySelector('img');
          if(im) im.style.setProperty('--z',(1.14-0.14*local).toFixed(4));
        }
        dots.forEach(function(d,k){
          d.style.setProperty('--p', k<i?1:(k===i?local.toFixed(3):0));
        });
      }

      function start(){ if(!timer){ timer=setInterval(function(){ upd(false); }, 60); } }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }

      /* olay gelirse aninda tepki — gelmezse yoklama yakalar */
      addEventListener('scroll', function(){ upd(false); }, {passive:true});
      addEventListener('resize', function(){ upd(true); }, {passive:true});
      addEventListener('orientationchange', function(){ upd(true); }, {passive:true});

      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(e.isIntersecting){ upd(true); start(); } else { stop(); }
          });
        }, {rootMargin:'200px'}).observe(sec);
      } else { start(); }

      [300, 1200, 3000].forEach(function(ms){ setTimeout(function(){ upd(true); }, ms); });
      upd(true);
    });
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){ init(); }); }
  else { init(); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  addEventListener('load', function(){ init(); });
})();
